import { useRequest } from 'domain/core/hooks/useRequest';
import { TUpdate } from 'domain/types';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { useContextSelector as useCS } from 'use-context-selector';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { useEffect } from 'react';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import { useNavigate } from 'react-router';
import { storageService } from 'infrastructure/services/StorageService';

export const useAuthGoogleMe = () => {
  const navigate = useNavigate();
  const globalUpdate: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  const { data, send, isLoading } = useRequest({
    url: '/api/v1/auth/me',
    sendOnStart: false,
  });

  useEffect(() => {
    if (isLoading || !data) return;
    if (data?.role?.id === 1) {
      storageService.removeItem('accessToken');
      storageService.removeItem('refreshToken');
      navigate('/auth/onboarding', { replace: true });
      return;
    }
    if (data?.role?.name === RolesEnum.GUEST) {
      navigate('/auth/choose-your-role', { replace: true });
      setTimeout(() => {
        window.history.pushState(null, '', window.location.href);
      }, 0);
      return;
    }
    if (data?.role?.name === RolesEnum.JOB_SEEKER) {
      globalUpdate?.({ userData: data, isReady: true });
      navigate('/profile/job-list', { replace: true });
      setTimeout(() => {
        window.history.pushState(null, '', window.location.href);
      }, 0);
      return;
    }
    if (data?.role?.name === RolesEnum.RECRUITER) {
      globalUpdate?.({ userData: data, isReady: true });
      navigate('/candidates/candidates-list', { replace: true });
      setTimeout(() => {
        window.history.pushState(null, '', window.location.href);
      }, 0);
    }
  }, [data, isLoading, globalUpdate]);

  return {
    isLoading,
    send,
  };
};
